import React, { useEffect } from 'react';
import { useGate, useStore } from 'effector-react';
import { formatSize } from 'pano-utils';
import { type LibItemMedia, LibType } from '@types';
import Title from '@components/Title';
import Button from '@components/Button';
import SearchBar from '../components/SearchBar';
import FooterClear from '../components/FooterClear';
import LibModalNav from '../layouts/LibModalNav';
import LibModalSpace from '../layouts/LibModalSpace';
import LibModal from '../layouts/LibModal';
import { LibItemsGate, LibMultipleGate } from '../stores/libState';
import libReset from '../actions/libReset';
import { $libSelected } from '../stores/libSelected';
import LibModalNavTip from '../layouts/LibModalNavTip';
import { LIB_FRAME_LIMIT, LIB_SIZE_LIMIT } from '../constants';
import ListSeqFrame from './ListSeqFrame';
import UploadButtonSeqFrame from './UploadButtonSeqFrame';

type Props = {
  multiple?: boolean;
  onConfirm: (result: { libItems: LibItemMedia[] }) => void;
  onRequestClose: () => void;
};

function LibSeqFrameModal({
  multiple = false,
  onConfirm,
  onRequestClose,
}: Props) {
  useGate(LibMultipleGate, multiple);
  useEffect(() => libReset, []);
  const noSelected = !useStore($libSelected).length;

  const handleConfirm = () => {
    const selected = $libSelected.getState();
    const items = (LibItemsGate.state.getState() as LibItemMedia[])
      .filter((x) => selected.includes(x.id))
      .sort((a, b) => selected.indexOf(a.id) - selected.indexOf(b.id));
    onConfirm({ libItems: items });
  };

  return (
    <LibModal
      header={
        <>
          <Title>逐帧图片素材库</Title>
          <SearchBar />
          <UploadButtonSeqFrame />
        </>
      }
      footer={
        <>
          <Button disabled={noSelected} onClick={handleConfirm}>
            确认操作
          </Button>
          <FooterClear />
        </>
      }
      onRequestClose={onRequestClose}
    >
      <LibModalNav
        navItems={[{ id: 'lib', name: '自定义素材' }] as const}
        selected="lib"
      >
        <LibModalSpace />
        <LibModalNavTip>
          <p>{`大小：${formatSize(
            LIB_SIZE_LIMIT[LibType.sequenceFrame]
          )}及以下/张`}</p>
          <p>格式：JPG、PNG</p>
          <p>{`数量：不超过${LIB_FRAME_LIMIT}张`}</p>
          <p>
            命名：使用后缀为“_XX”命名，XX为从1开始的连续数字, 如:
            图片名称_1.jpg, 图片名称_2.jpg, …图片名称_72.jpg
          </p>
        </LibModalNavTip>
      </LibModalNav>
      <ListSeqFrame />
    </LibModal>
  );
}

export default LibSeqFrameModal;
